module.exports = __webpack_public_path__ + "static/media/user-robot.7221ad39.svg";